export default {"src":"/_next/static/media/wind.2b0d30dc.svg","height":11,"width":12,"blurWidth":0,"blurHeight":0};